const demoPages = {
  Icons: {
    route: 'icons',
    component: 'IconsDemo',
    children: [],
  },
  ColorProfiles: {
    route: 'color-profiles',
    component: 'ColorProfilesDemo',
    children: [],
  },
  ContentBlocks: {
    route: 'content-blocks',
    component: 'ContentBlocksDemo',
    children: [],
  },
};

module.exports = demoPages;
